import object from '@mailobj-browser/front/js/utils/object.js'

export const audioStates = object(null, {
  unmute: 'unmute',
  mute: 'mute'
})

let _audioState = audioStates.unmute

export const setAudioState = (state) => {
  if (!Object.hasOwn(audioStates, state)) {
    throw new Error("bad audio state provided: " + state)
  }
  _audioState = state
}

export const getAudioState = () => {
  return _audioState
}

